// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__xu-sn","content":"LoadingAlert_content__1g0NS"};